const MachineReadableEPDKey = {
  GTIN: 'GTIN',
  DECLARED_UNIT_AND_REFERENCE_FLOW: 'Declared unit and reference flow',
  REFERENCE_FLOW: 'Reference flow',
  MATERIAL_PROPERTIES: 'Material properties',
  GEOGRAPHICAL_SCOPE_DESCRIPTION: 'Geographical scope description',
  TECHNOLOGY_DESCRIPTION: 'Technology description including background system',
  TECHNICAL_PURPOSE: 'Technical purpose of product or process',
  SUBTYPE: 'Subtype for ILCD+EPD',
  DATA_SOURCES: 'Data sources used for this data set',
  REFERENCE_PACKAGE_VERSION_15804: 'Version of the EN 15804 reference package',
  CHARACTERISATION_METHODS: 'Characterisation methods',
  ADDITIONAL_INFORMATION_ABOUT_THE_UNDERLYING_LCA_BASED_INFORMATION:
    'Additional information about the underlying LCA-based information',
  USE_ADVICE: 'Use advice for the EPD',
  EPD_BASED_ON_UNIT: 'EPD based on declared or functional unit',
  FUNCTIONAL_UNIT_DESCRIPTION: 'Functional unit description',
  PRODUCT_TO_DECLARE: 'Product to declare',
  BIOGENIC_CARBON_CONTENT: 'Biogenic carbon content',
  PRODUCT_CONTAIN_MORE_THAN_5_BIOGENIC_CARBON: 'Does the product contain more than 5% biogenic carbon',
  PACKAGE_CONTAIN_MORE_THAN_5_BIOGENIC_CARBON: 'Does the packaging material contain more than 5% biogenic carbon',
  BIOGENIC_CARBON_CONTENT_OF_PRODUCT: 'Biogenic carbon content of product',
  BIOGENIC_CARBON_CONTENT_OF_PACKAGE: 'Biogenic carbon content in accompanying package',
};

export default MachineReadableEPDKey;
